import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';

function Cancel() {
    const navigate = useNavigate();

    return (
        <div
            style={{
                textAlign: 'center',
                marginTop: '80px',
                marginBottom: '80px',
                padding: '40px 20px',
            }}
        >
            <div
                style={{
                    maxWidth: '600px',
                    margin: '0 auto',
                    background: '#fff',
                    borderRadius: '16px',
                    padding: '50px 40px',
                    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
                }}
            >
                <div
                    style={{
                        fontSize: '4rem',
                        marginBottom: '20px',
                        color: '#ff6b6b',
                    }}
                >
                    ✕
                </div>
                <h1
                    style={{
                        fontSize: '2.5rem',
                        fontWeight: '700',
                        color: '#0d1b2a',
                        marginBottom: '20px',
                    }}
                >
                    Payment Cancelled
                </h1>
                <p
                    style={{
                        fontSize: '1.1rem',
                        color: '#6c757d',
                        lineHeight: '1.6',
                        marginBottom: '15px',
                        padding: '1rem',
                    }}
                >
                    Your payment was cancelled and no charges were made.
                </p>
                <div
                    style={{
                        display: 'flex',
                        gap: '15px',
                        justifyContent: 'center',
                        flexWrap: 'wrap',
                    }}
                >
                    <Button
                        style={{
                            backgroundColor: '#0d1b2a',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            padding: '12px 30px',
                            fontSize: '1rem',
                            fontWeight: '500',
                            transition: 'all 0.2s ease',
                            minWidth: '180px',
                        }}
                        onClick={() => navigate('/')}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#1a2f4a';
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 4px 8px rgba(13, 27, 42, 0.2)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#0d1b2a';
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = 'none';
                        }}
                    >
                        Continue Shopping
                    </Button>
                </div>

                <div
                    style={{
                        marginTop: '40px',
                        paddingTop: '30px',
                        borderTop: '1px solid #e9ecef',
                    }}
                >
                    <p
                        style={{
                            fontSize: '0.9rem',
                            color: '#6c757d',
                            marginBottom: '10px',
                        }}
                    >
                        Need help?
                    </p>
                    <p
                        style={{
                            fontSize: '0.9rem',
                            color: '#0d1b2a',
                            marginBottom: '20px',
                        }}
                    >
                        Contact us if you experienced any issues during checkout.
                    </p>
                    <Button
                        variant="outline-primary"
                        as="a"
                        href="https://fullstack.cash/contact"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            borderColor: '#0d1b2a',
                            color: '#0d1b2a',
                            borderRadius: '8px',
                            padding: '10px 25px',
                            fontSize: '0.9rem',
                            fontWeight: '500',
                            transition: 'all 0.2s ease',
                            textDecoration: 'none',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#0d1b2a';
                            e.currentTarget.style.color = 'white';
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 4px 8px rgba(13, 27, 42, 0.2)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'transparent';
                            e.currentTarget.style.color = '#0d1b2a';
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = 'none';
                        }}
                    >
                        Contact Us
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default Cancel;
